var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"min-h-screen flex items-center justify-center bg-gray-200 py-12 px-4 sm:px-6 lg:px-8"},[_c('div',{staticClass:"max-w-md w-full"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }